import React, {
  useCallback,
} from 'react';
import {
  getStatus,
} from 'redux-resource';
import {
  useSelector,
  shallowEqual,
} from 'react-redux';
import {
  Redirect,
} from 'react-router-dom';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Spinner,
  NotFound,
} from 'web-components';

import {
  MainHeader,
  MainSidebar,
} from 'web-containers';

import Modals from './Modals';
import * as S from './styled';

type Props = {
  onlyPro?: boolean;
  onlyClient?: boolean;
  options?: any;
  component: any;
  routeProps: any;
  statusLocations?: string[];
};

const PrivateLayout = ({
  onlyPro,
  onlyClient,
  options,
  routeProps,
  statusLocations,
  component: Component,
}: Props) => {
  const mapState = useCallback(state => ({
    profile: coreSelectors.getProfile(state),
    readStatus: getStatus(
      state,
      statusLocations || [],
      true,
    ),
  }), [statusLocations]);
  const { profile, readStatus } = useSelector(mapState, shallowEqual);

  const {
    isAuth,
    isLoading,
  } = profile;

  const failed = (!isLoading && !isAuth) || readStatus.failed;
  const success = !isLoading && isAuth && readStatus.succeeded;

  if (!profile.hasToken) return (<Redirect to="/login" />);
  if (success && !profile.is_pro && onlyPro) return (<Redirect to="/welcome" />);
  if (success && profile.is_pro && onlyClient) return (<Redirect to="/welcome" />);

  return (
    <>
      {success && (
        <S.Layout>
          <MainSidebar />
          <S.Main id="main">
            <MainHeader
              profile={profile}
            />
            <S.Content id="content">
              <Component
                {...routeProps}
                {...options}
              />
            </S.Content>
          </S.Main>

          {/* Global Modals */}
          <Modals />
        </S.Layout>
      )}

      {(isLoading || readStatus.pending) && (
        <Spinner />
      )}

      {failed && (
        <NotFound title="Loading failed" />
      )}
    </>
  );
};

PrivateLayout.defaultProps = {
  options: {},
  onlyPro: null,
  onlyClient: null,
  statusLocations: null,
};

export default PrivateLayout;
